import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetUserWalletAmount = async (userID) => {
    const url = `${NewUpdatedBaseUrl}/UserWallet/GetUserWalletAmount?UserKeyID=${userID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
export const GetWalletTransactionList = async (userID) => {
    const url = `${BaseUrl}/UserWallet/GetWalletTransactionList?UserID=${userID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
export const GetUserReferencedList = async (userID) => {
    const url = `${BaseUrl}/UserWallet/GetUserReferencedList?UserID=${userID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
